import { createAction } from 'Helpers';
import walletPaymentTypes from './types';

const walletPaymentActions = {
	newTransactionRequest: createAction(
		walletPaymentTypes.NEW_TRANSACTION.REQUEST
	),
	newTransactionSuccess: createAction(
		walletPaymentTypes.NEW_TRANSACTION.SUCCESS
	),
	newTransactionFailure: createAction(
		walletPaymentTypes.NEW_TRANSACTION.FAILURE
	),

	checkBarcodeRequest: createAction(walletPaymentTypes.CHECK_BARCODE.REQUEST),
	checkBarcodeSuccess: createAction(walletPaymentTypes.CHECK_BARCODE.SUCCESS),
	checkBarcodeFailure: createAction(walletPaymentTypes.CHECK_BARCODE.FAILURE),
	checkBarcodeClear: createAction(walletPaymentTypes.CHECK_BARCODE.CLEAR),

	insufficientBalance: createAction(walletPaymentTypes.INSUFFICIENT_BALANCE),
	clearAmount: createAction(walletPaymentTypes.CLEAR_AMOUNT),
	generalError: createAction(walletPaymentTypes.GENERAL_ERROR, (error) => ({
		payload: error,
	})),
	walletTransactionRequest: createAction(
		walletPaymentTypes.WALLET_TRANSACTION.REQUEST
	),
	walletTransactionSuccess: createAction(
		walletPaymentTypes.WALLET_TRANSACTION.SUCCESS
	),
	walletTransactionFailure: createAction(
		walletPaymentTypes.WALLET_TRANSACTION.FAILURE
	),
	walletTransactionClear: createAction(
		walletPaymentTypes.WALLET_TRANSACTION.CLEAR
	),
};

export default walletPaymentActions;
